import React from 'react'

const ErrorPage = () => {
  return (
    <div className='w-full h-full flex justify-center items-center text-white text-[20px]'>
      this is error page
    </div>
  )
}

export default ErrorPage
